import EventDetailSchedules from '@/screens/EventDetailSchedules';

import useRootStore from '@/stores/useRootStore';

export default function PrivateTabsOrganizationMainIndexRoute() {
  const organizationId = useRootStore((state) => state.organizationId);

  return (
    <EventDetailSchedules
      basePath="/organization/schedule/(scheduleA)/[eventId]"
      eventId={organizationId || ''}
    />
  );
}
